module.exports = __webpack_public_path__ + "media/images/digital1-63e7345951fe61d64828e0a2035a6f90.png";